import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { PopUpGallery } from './PhotoGallery';
import Loading from './Loading';
import VendorProfileSection from './VendorProfileSection';

const PostsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 12px;

  @media (max-width: 600px) {
    grid-gap: 6px;
  }
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
`;

const formatFullSizeImages = images =>
  Object.values(images)
    .map(o => ({
      timestamp: o.taken_at_timestamp,
      src: o.original,
      caption: '',
    }))
    .sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));

const formatThumbnails = images =>
  Object.values(images)
    .map(o => o)
    .sort((a, b) => (a.taken_at_timestamp > b.taken_at_timestamp ? 1 : -1));

export default function Instagram({ vendorId }) {
  const instagram = useSelector(state => state.instagram[vendorId]);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = index => {
    setCurrentImage(index);
    setViewerIsOpen(true);
    // trackEvent({ event: "open-gallery", userId, vendorId });
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
    // trackEvent({ event: "close-gallery", userId, vendorId });
  };

  if (
    !instagram ||
    !instagram.posts ||
    Object.keys(instagram.posts).length < 1
  ) {
    return null;
  }
  if (instagram.is_fetching) {
    return <Loading />;
  }
  const thumbnails = formatThumbnails(instagram.posts);

  return (
    <VendorProfileSection title={`@${instagram.username}`} ellipsis>
      <div>
        <PopUpGallery
          viewerIsOpen={viewerIsOpen}
          closeLightbox={closeLightbox}
          currentImage={currentImage}
          images={formatFullSizeImages(instagram.posts)}
          imagesToPreload={13}
        />
        <PostsWrapper>
          {thumbnails.length &&
            thumbnails.map((post, index) => {
              return (
                (post.thumbnails && post.thumbnails.small && (
                  <div key={index}>
                    <Image
                      src={post.thumbnails.small.src}
                      onClick={() => openLightbox(index)}
                    />
                  </div>
                )) ||
                null
              );
            })}
        </PostsWrapper>
      </div>
    </VendorProfileSection>
  );
}
